<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("assessments/delete", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "assessments" });
        this.$notify({
          type: "success",
          message: this.$t('assessments.message.successdelete')
        });
      })
      .catch(error => {
        this.$notify({
          type: "danger",
          message: "Error! The data could not be erased."
        });
      });
  }
};
</script>
<style>
</style>
